import { render, staticRenderFns } from "./RoomList.vue?vue&type=template&id=5ab6770d&lang=pug&"
import script from "./RoomList.vue?vue&type=script&lang=ts&"
export * from "./RoomList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports